import { usingPost } from '@ocean/api'
import { StaAuthenticationQueryParams } from 'modules/redirects/StaRedirect/types'

export const userStaAuthentication = (authParams: StaAuthenticationQueryParams) => {
  const { ost, company, userId } = authParams
  return usingPost(
    'session/authenticationFromSta',
    { customer: company, userId, oceanSessionToken: ost },
    { useProxy: true }
  )
}
